<div class="scroll-container blue-scroll-bar">
  <div class="flex-container pt-20 pb-10">
    <div class="about-us-content">
      <img class="about-us-logo" src="./assets/media/logo-grafinia-1.png" alt="Logo" />
      <div>
        <h2 class="text-color primary">SALUT</h2>
        <p class="text-color secondary"> 
            Creștem notorietatea business-urilor 
        </p>
        <p class="text-color secondary">
          Grafinia este tărâmul design-ului grafic bazat pe inovare continuă în
          domeniul serviciilor de creație, design și DTP (Desktop publishing).
        </p>
      </div>
    </div>
    <div class="about-us-content">
      <h2 class="text-color primary">ÎȚI OFERIM</h2>
      <h2 class="text-color primary">Design grafic print</h2>
      <ul>
        <li class="text-color secondary">
          DesignStart - design logo, design carte vizită, design mapă de
          prezentare, design foi cu antet, design notes
        </li>
        <li class="text-color secondary">
          DesignBrand - design flyer, design afiș, design pliant, design card,
          design broșură, design roll-up, design steag
        </li>
        <li class="text-color secondary">
          DesignProfesional - Design HORECA (design meniu, design suport masă,
          design table tent, design notes ospătar, design door hanger), Design
          Spălătorie Auto (design suport picioare)
        </li>
        <li class="text-color secondary">
          Design Ambalaje - Design Cofetărie (design cutii tort, design cutii
          brioșe, design cutii prăjituri), Design Fast Food (design cutii
          burger, design cutii cartofi, design tăvițe, design cutii salată)
        </li>
        <li class="text-color secondary">
          Design Promoționale - Design Agende, Design Calendare, Design Pixuri,
          Design Ecusoane, Design Semne de carte
        </li>
      </ul>
      <h2 class="text-color primary">Design grafic online</h2>
      <ul>
        <li class="text-color secondary">
          Design facebook - design profil, design copertă, design copertă
          magazin, design story, design postare
        </li>
        <li class="text-color secondary">Design instagram - design profil, design story, design postare</li>
        <li class="text-color secondary">Design LinkedIn - design profil, design perete, design postare</li>
      </ul>
    </div>
  </div>
  <div class="flex-container pt-10 pb-20 primary-bg">
    <div class="about-us-content">
      <h1 class="text-color white">CINE SUNTEM</h1>
      <p class="text-color white">
        <span class="pl-8">Grafinia</span> este un startup inovativ. Ideea de afacere a
        pornit de la dorința de dezvoltare continuă, pasiunea pentru
        calculatoare și design și de la identificarea unei nevoi nesatisfăcute
        în piața locală și regională și anume cea a serviciilor de grafică
        dedicate atât comunicării online, cât și offline, mai ales cele dedicate
        industriei tipografice. Ideea de afacere constă în utilizarea
        imaginației și a softurilor necesare care să permită realizarea de
        machete grafice dedicate acestui sector.
      </p>
      <p class="text-color white">
        <span class="pl-8">Soluția</span> propusă vine sub forma unor softuri specializate și
        a unei platforme online ce permite crearea, administrarea și
        distribuirea machetelor grafice, comunicarea și interacțiunea în timp
        real cu clientul pe baza unui cont dedicat și a unui cont FTP cu rol în
        satisfacerea eficientă a nevoilor acestora.
      </p>
      <p class="text-color white">
        <span class="pl-8">Elementul</span> inovator adus de către Grafinia Design combină
        modelul de business, cu tehnologia, cercetarea inovațională și abordarea
        proactivă a pieței, oferind publicului țintă un concept complex prin
        intermediul unei platforme online interactive.
      </p>
      <p class="text-color white">
        <span class="pl-8">Vrem</span> să susținem firmele mici și mijlocii, care sunt la
        început de drum și își doresc realizarea unei identități vizuale, cât și
        pe cele care vizează creșterea vizibilității organizației lor.
      </p>
      <p class="text-color white">
        <span class="pl-8">Produsele</span> noastre sunt destinate în principal firmelor care
        își doresc creșterea vizibilității și au nevoie de servicii de design
        grafic și în același timp, ne adresăm unui segment de piață de nișă și
        anume tipografiilor care tipăresc materialele realizate și au nevoie de
        servicii de DTP.
      </p>
      <p class="text-color white">
        <span class="pl-8">Suntem</span> inventivi, deschiși către nou și original, bine
        organizați și determinați !
      </p>
      <p class="text-color white">
        <span class="pl-8">O</span> echipă dinamică care acordă o importanță deosebită atât
        perfecționării profesionale continue, cât și menținerii unui contact
        permanent cu clienții pentru a cunoaște cerințele acestora și a veni în
        întâmpinarea lor cu soluţii originale.
      </p>
      <h1 class="text-color white">SCOPUL</h1>
      <p class="text-color white">
        <span class="pl-8">Scopul</span> nostru este să răspundem nevoilor organizațiilor de
        a-și crește vizibilitatea și a realiza materiale publicitare, etichete
        și ambalaje utile, creative și eficiente. Să dăm viață brandurilor și să
        facem lucrurile frumoase. Și să o facem bine și în timpul în care are
        nevoie clientul astfel încât rezultatul să-i ofere valoare.
      </p>
      <p class="text-color white">
        <span class="pl-8">Serviciul</span> oferit este unul complex, ce implică marketing,
        marketing digital, comunicare, cunoștințe avansate a programelor de
        software, atenție la detalii, echipamente tehnice, softuri specializate
        și implementare. Serviciile oferite presupun implicarea firmei și în
        faza de cercetare și auditare a imaginii actuale a potențialului client
        sau a competitorilor.
      </p>
    </div>
    <div class="about-us-content">
      <h1 class="text-color white">MISIUNEA FIRMEI</h1>
      <p class="text-color white">
        <span class="pl-8">Misiunea</span> firmei este aceea de a contribui la succesul
        partenerilor noștri, de a da viață oricărui produs, de a-i crește
        vizibilitatea și a-l face atractiv. Cercetăm, identificăm, desenăm și
        realizăm servicii grafice personalizate astfel încât clienții noștri să
        fie vizibili.
      </p>
      <p class="text-color white">
        <span class="pl-8">Pentru</span> noi este important să reușim să transformăm orice
        produs obișnuit într-unul spectaculos, viu, vizibil și atractiv. Să
        creștem prin grija deosebită pe care o arătăm clienților, angajaților și
        partenerilor noștri de afaceri devenind un model de responsabilitate
        socială, etică și corectitudine față de mediul înconjurător. Și toți
        actorii implicați să poată contribui la dezvoltarea comunității locale
        din care fac parte.
      </p>
      <p class="text-color white">
        <span class="pl-8">Din</span> ce în ce mai multe firme înțeleg importanța designul
        grafic și îl percep ca pe un instrument masiv, versatil și necesar în
        strategia de marketing a companiei, iar dacă ești un start-up aflat la
        început de drum ai o reală nevoie de afirmare și de realizare a
        identității vizuale
      </p>
      <h1 class="text-color white">Viziunea afacerii propuse/firmei</h1>
      <p class="text-color white">
        <span class="pl-8">Viziunea</span> noastră este să ajutăm firmele să dea viață
        brandurilor, liantul dintre firme și tipar, designerul preferat din zonă
        și nu numai unde firmele găsesc soluții personalizate, oferite într-un
        mod plăcut și facil, folosind tehnologie de ultimă generație. Locul unde
        clienții, angajații și partenerii noștri își împărtășesc unii altora
        experiența și mobilizează resurse pentru a crea valoare.
      </p>
      <p class="text-color white">
        <span class="pl-8">Grafinia</span> Design își propune să atingă performanțe
        financiare de top pe termen lung prin integrarea sustenabilității în
        strategia de business, lăsând totodată o amprentă pozitivă asupra
        societății și mediului înconjurător.
      </p>
      <p class="text-color white">
        <span class="pl-8">Elementul</span> de inovație adus sectorului serviciilor de
        creație, design și DTP și anume platforma online ce va permite
        clienților accesarea de la distanță a serviciilor organizației pe baza
        unui cont de client dedicat, a unui spațiu de stocare a datelor alocat
        fiecărui client și implicarea firmei în interacțiunea cu acesta îi oferă
        un element clar de diferențiere față de concurență.
      </p>
    </div>
  </div>
</div>
